/**
 * "syncanix init — discover your API" — CLI section (ADR-0074).
 * Reconciled from packages/cli/src/commands/init/register.ts + enrich/consent.
 * The full init flag set and the real enrichment modes (local-keys / byok /
 * skip — there is no Syncanix-hosted enrichment service) are documented here.
 */
import type { DocPageContent } from '../types';

export const CLI_INIT_PAGE: DocPageContent = {
  slug: 'cli/init',
  titleKey: 'docs.cli.init.title',
  descriptionKey: 'docs.cli.init.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.cli.init.lead' },
    { kind: 'code', language: 'bash', code: 'npx syncanix init' },

    { kind: 'heading', level: 2, id: 'options', textKey: 'docs.cli.init.options.heading' },
    {
      kind: 'definitions',
      variant: 'code',
      items: [
        {
          termKey: 'docs.cli.init.opt.framework.term',
          descKey: 'docs.cli.init.opt.framework.desc',
        },
        { termKey: 'docs.cli.init.opt.env.term', descKey: 'docs.cli.init.opt.env.desc' },
        { termKey: 'docs.cli.init.opt.offline.term', descKey: 'docs.cli.init.opt.offline.desc' },
        { termKey: 'docs.cli.init.opt.yes.term', descKey: 'docs.cli.init.opt.yes.desc' },
        { termKey: 'docs.cli.init.opt.byokKey.term', descKey: 'docs.cli.init.opt.byokKey.desc' },
        {
          termKey: 'docs.cli.init.opt.byokProvider.term',
          descKey: 'docs.cli.init.opt.byokProvider.desc',
        },
        { termKey: 'docs.cli.init.opt.force.term', descKey: 'docs.cli.init.opt.force.desc' },
        {
          termKey: 'docs.cli.init.opt.resetConsent.term',
          descKey: 'docs.cli.init.opt.resetConsent.desc',
        },
        {
          termKey: 'docs.cli.init.opt.initConfig.term',
          descKey: 'docs.cli.init.opt.initConfig.desc',
        },
        {
          termKey: 'docs.cli.init.opt.graphqlEndpoint.term',
          descKey: 'docs.cli.init.opt.graphqlEndpoint.desc',
        },
        {
          termKey: 'docs.cli.init.opt.telemetry.term',
          descKey: 'docs.cli.init.opt.telemetry.desc',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'what-happens', textKey: 'docs.cli.init.steps.heading' },
    {
      kind: 'steps',
      steps: [
        { titleKey: 'docs.cli.init.step.detect.title', textKey: 'docs.cli.init.step.detect.text' },
        {
          titleKey: 'docs.cli.init.step.extract.title',
          textKey: 'docs.cli.init.step.extract.text',
        },
        { titleKey: 'docs.cli.init.step.ignore.title', textKey: 'docs.cli.init.step.ignore.text' },
        {
          titleKey: 'docs.cli.init.step.consent.title',
          textKey: 'docs.cli.init.step.consent.text',
        },
        { titleKey: 'docs.cli.init.step.write.title', textKey: 'docs.cli.init.step.write.text' },
        { titleKey: 'docs.cli.init.step.upload.title', textKey: 'docs.cli.init.step.upload.text' },
      ],
    },

    { kind: 'heading', level: 2, id: 'static', textKey: 'docs.cli.init.static.heading' },
    { kind: 'paragraph', textKey: 'docs.cli.init.static.body' },

    { kind: 'heading', level: 2, id: 'consent', textKey: 'docs.cli.init.consent.heading' },
    { kind: 'paragraph', textKey: 'docs.cli.init.consent.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.cli.init.consent.localKeys.term',
          descKey: 'docs.cli.init.consent.localKeys.desc',
        },
        { termKey: 'docs.cli.init.consent.byok.term', descKey: 'docs.cli.init.consent.byok.desc' },
        { termKey: 'docs.cli.init.consent.skip.term', descKey: 'docs.cli.init.consent.skip.desc' },
      ],
    },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.cli.init.consent.note.title',
      textKey: 'docs.cli.init.consent.note.body',
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.cli.init.reset.title',
      textKey: 'docs.cli.init.reset.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.cli.init.next.config.title',
          textKey: 'docs.cli.init.next.config.text',
          to: { docSlug: 'cli/commands' },
        },
        {
          titleKey: 'docs.cli.init.next.catalog.title',
          textKey: 'docs.cli.init.next.catalog.text',
          to: { docSlug: 'catalog' },
        },
      ],
    },
  ],
};
